import { decomposeHex } from "./decomposeHex";

export function DetermineBrightness(color) {
  var [R, G, B] = decomposeHex(color);
  return Math.sqrt(R * R * 0.241 + G * G * 0.691 + B * B * 0.068);
}
